import { useEffect } from 'react';
import { option } from 'fp-ts';
import { CATALOG_DATA_TYPE } from 'modules/catalog/catalogConstants';
import { useUpdateFieldsForProperty } from 'modules/queryBuilder/legacyQueryBuilder/hooks';
import { useCatalogContext } from 'modules/catalog/catalogSelector';
import { useFetchCatalogFields } from 'modules/catalogFieldTypes/hooks';
import { useCatalogFieldFacets } from 'modules/catalog/hooks/useCatalogFieldFacets';
import { isDefined } from 'utils/tsHelpers';

/** updates query buidler fields whenever anything in dependancy changes */
export const useUpdateBuilderFields = () => {
  const update = useUpdateFieldsForProperty();
  const updateCatalogInBuilder = useCatalogFieldFacets();
  const { catalog, catalogFieldDetails } = useCatalogContext();
  const { data } = useFetchCatalogFields(option.toUndefined(catalog)?.name);

  useEffect(() => {
    const catalogName = option.toUndefined(catalog)?.name;
    update(CATALOG_DATA_TYPE, data);
    if (isDefined(catalogName)) updateCatalogInBuilder(catalogName);
  }, [data, catalog, catalogFieldDetails]);
};
